import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { PageWidget } from '../../models/widget/page-widget.model';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class WidgetService {
  private service = "api/Widget"; //Controller Name
  public widgetTemplateList: WidgetTemplate[];
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  // Region Widget Template

  GetWidgetTemplates() {
    return this.http.get(`${this.service}/GetDefinedWidgetTemplates`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPageWidgetsByPageID(dynamicPageID: number, widgetTemplateId: number) {
    return this.http.get(`${this.service}/GetPageWidgetsByPageID?DynamicPageID=` + dynamicPageID + "&widgetTemplateId=" + widgetTemplateId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPageWidgetsById(id: string) {
    return this.http.get(`${this.service}/GetPageWidgetsById?Id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSortedPageWidgetsByPageID(dynamicPageID: number, widgetTemplateId: number) {
    return this.http.get(`${this.service}/GetSortedPageWidgetsByPageID?DynamicPageID=` + dynamicPageID + "&widgetTemplateId=" + widgetTemplateId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAllWidgetContentsOfProducts(widgetTemplateId: number) {
    return this.http.get(`${this.service}/GetAllWidgetContentsOfProducts?widgetTemplateID=` + widgetTemplateId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetDynamicPages() {
    return this.http.get(`${this.service}/GetDynamicPages`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  SaveImage(formData: any) {
    return this.http
      .post(`${this.service}/SaveImage`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response)
      .catch(this.errorHandler);
  }
  SaveWidget(pageWidget: PageWidget) {
    return this.http
      .post(`${this.service}/PostWidget`, pageWidget, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response)
      .catch(this.errorHandler);
  }
  UpdateWidgetSorting(sortOrderData: string) {
    return this.http
      .post(`${this.service}/UpdateWidgetSorting?sortOrderData=` + sortOrderData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response)
      .catch(this.errorHandler);
  }
  DeletePageWidget(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  // End Region Widget Template
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widget/widget.service.ts